import {logError} from '@oc/utils'

export enum NotificationType {
    info = 'info',
    warning = 'warning',
    error = 'error',
    success = 'success'
}

export interface Notification {
    type: NotificationType
    message: string
    persist?: boolean
}

export interface NotificationOptions {
    persist?: boolean
}

export type NotificationHandler = (not: Notification) => void

export class SnackHandler {
    private queue: Notification[] = []
    private handler: NotificationHandler | undefined

    public handle = (handler: NotificationHandler) => {
        this.queue.forEach(handler)
        this.queue.splice(0)
        this.handler = handler
    }

    public unhandle = () => {
        this.handler = undefined
    }

    public info = (msg: string, opts?: NotificationOptions) => {
        this.push({
            type: NotificationType.info,
            message: msg,
            persist: opts?.persist
        })
    }

    public success = (msg: string, opts?: NotificationOptions) => {
        this.push({
            type: NotificationType.success,
            message: msg,
            persist: opts?.persist
        })
    }

    public warning = (msg: string, opts?: NotificationOptions) => {
        this.push({
            type: NotificationType.warning,
            message: msg,
            persist: opts?.persist
        })
    }

    public logError = (err: any, opts?: NotificationOptions) => {
        if (err) {
            if (err.response && err.response.data && err.response.data.message) {
                this.error(err.response.data.message, opts)
            } else if (err.message) {
                this.error(err.message, opts)
            } else {
                this.error(err, opts)
            }

            logError(typeof err === 'object' && err && 'toJSON' in err ? err.toJSON : err)
        }
    }

    public error = (msg: string, opts?: NotificationOptions) => {
        this.push({
            type: NotificationType.error,
            message: `${msg}`.replace(/^"+(.*)"+$/, '$1'),
            persist: opts?.persist
        })
    }

    private push = (not: Notification) => {
        if (!not.persist) {
            delete not.persist
        }

        if (this.handler) {
            this.handler(not)
        } else {
            this.queue.push(not)
        }
    }
}

const snackHandler = new SnackHandler()
export default snackHandler
